import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CardAnnouncement } from '../cards/student/announcement-card/card-announcement';
import { CardAnnouncementModalComponent } from '../cards/student/announcement-card/card-announcement-modal/card-announcement-modal.component';
import { StudentSummaryService } from '../student-summary.service';
import { Router } from '@angular/router';
import { LoginService } from '../../../shared-modules/login/login.service';
import { Announcement } from '../../../shared-modules/announcement/announcement.model';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

@Component({
    selector: 'app-new-announcements-modal',
    templateUrl: './new-announcements-modal.component.html',
    styleUrls: ['./new-announcements-modal.component.css']
})
export class NewAnnouncementsModalComponent implements OnInit {
    v10: boolean;
    districtAnnouncements: CardAnnouncement[] = [];
    schoolAnnouncements: CardAnnouncement[] = [];
    classroomAnnouncements: CardAnnouncement[] = [];
    siteDailyAnnouncement: Announcement[] = [];
    @ViewChildren('textArea') textAreas: QueryList<ElementRef>;

    showTableFlags = [false, false, false];
    showTableDailyFlags = [false, false, false];
    sectionNames = ['District Announcements', 'School Announcements', 'Class Announcements'];
    districtMessages: Announcement[] = [];
    subscriptions: Subscription[] = [];
    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    tableData: TylerMatTableDataSource[] = [];
    tableDailyData: TylerMatTableDataSource[] = [];
    siteAnnouncement: TylerMatTableDataSource[] = [];
    siteDailyAnnouncementTable: TylerMatTableDataSource[] = [];
    schoolName: string[] = [];
    schoolNameDaily: string[] = [];
    constructor(private router: Router, private dialogRef: MatDialogRef<NewAnnouncementsModalComponent>, @Inject(MAT_DIALOG_DATA) public announcements: any, private dialog: MatDialog, private studentSummaryService: StudentSummaryService, private loginService: LoginService,) {
        this.v10 = this.loginService.LoginSettings.V10;
    }

    ngOnInit() {
        if (this.v10) {
            this.sortAnnouncements();
        }
        else {
            this.sortAnnouncementsV9();
        }
        this.studentSummaryService.hasSeenNewAnnouncementModal = true;
    }

    checkOverflow(element) {
        return element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth;
    }

    sortAnnouncements() {
        // Sort the announcements by type
        let idx = 0;
        this.districtAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'District');
        this.schoolAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'School');
        this.classroomAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'Classroom');

        setTimeout(() => {
            this.districtAnnouncements.forEach((announcement) => {
                const ta = this.textAreas.toArray()[idx];
                if (ta != undefined) {
                    announcement.Overflow = this.checkOverflow(ta.nativeElement);
                    idx++;
                }
            });
            this.schoolAnnouncements.forEach((announcement) => {
                const ta = this.textAreas.toArray()[idx];
                if (ta != undefined) {
                    announcement.Overflow = this.checkOverflow(ta.nativeElement);
                    idx++;
                }
            });
            this.classroomAnnouncements.forEach((announcement) => {
                const ta = this.textAreas.toArray()[idx];
                if (ta != undefined) {
                    announcement.Overflow = this.checkOverflow(ta.nativeElement);
                    idx++;
                }
            });
        }, 0);
    }

    sortAnnouncementsV9() {
        this.siteDailyAnnouncement = this.announcements.filter(x => x.ShowDaily == true);
        this.siteDailyAnnouncementTable[0] = new TylerMatTableDataSource(this.siteDailyAnnouncement);

        this.announcements = this.announcements.filter(x => x.IsNewAnnouncement == true);
        this.siteAnnouncement[0] = new TylerMatTableDataSource(this.announcements.filter(x => x.AnnouncementType == 'S' && x.IsNewAnnouncement == true));
        this.siteAnnouncement[0].data.forEach(obj => {
            if (this.schoolName.length > 0) {
                if (!this.schoolName.includes(obj.SchoolName)) {
                    this.schoolName.push(obj.SchoolName);
                }
            }
            else {
                this.schoolName.push(obj.SchoolName);
            }
        });
        this.siteDailyAnnouncementTable[0].data.filter(x => x.AnnouncementType == 'S').forEach(obj => {
            if (this.schoolNameDaily.length > 0) {
                if (!this.schoolNameDaily.includes(obj.SchoolName)) {
                    this.schoolNameDaily.push(obj.SchoolName);
                }
            }
            else {
                this.schoolNameDaily.push(obj.SchoolName);
            }
        });
        this.tableData[1] = this.siteAnnouncement[0];
        this.tableDailyData[1] = this.siteDailyAnnouncementTable[0];
        this.subscriptions.push(
            this.toggleAllRows.subscribe(toggle => {
                this.tableDailyData[0].expandAll(toggle);
                this.tableDailyData[1].expandAll(toggle);
                this.tableDailyData[2].expandAll(toggle);
            })
        );
        this.subscriptions.push(
            this.toggleAllRows.subscribe(toggle => {
                this.tableData[0].expandAll(toggle);
                this.tableData[1].expandAll(toggle);
                this.tableData[2].expandAll(toggle);
            })
        );
        this.virtualizeDaily();
        this.virtualize();
    }

    virtualize() {
        // POST: transforms announcements into grid data

        // District student announcements
        const districtData = this.filterAnnouncements(this.announcements, 'D');
        this.tableData[0] = new TylerMatTableDataSource(districtData);
        this.showTableFlags[0] = districtData.length > 0;

        // School staff announcements
        // const schoolData = this.filterAnnouncements(this.announcements, 'S');
        // this.tableData[1] = new TylerMatTableDataSource(schoolData);
        // this.showTableFlags[1] = schoolData.length > 0;

        // Class staff announcements
        const classData = this.filterAnnouncements(this.announcements, 'C');
        this.tableData[2] = new TylerMatTableDataSource(classData);
        this.showTableFlags[2] = classData.length > 0;

        // District Message
        this.districtMessages = this.filterAnnouncements(this.announcements, 'M');
    }

    virtualizeDaily() {
        const districtData = this.filterAnnouncements(this.siteDailyAnnouncement, 'D');
        this.tableDailyData[0] = new TylerMatTableDataSource(districtData);
        this.showTableDailyFlags[0] = districtData.length > 0;

        // Class staff announcements
        const classData = this.filterAnnouncements(this.siteDailyAnnouncement, 'C');
        this.tableDailyData[2] = new TylerMatTableDataSource(classData);
        this.showTableDailyFlags[2] = classData.length > 0;
    }

    private filterAnnouncements(announcements: Announcement[], type: string) {
        // PRE: a list of announcements and a single character type indicator
        // POST: filters the announcements for a given type. Returns those announcements whose type matches.
        return announcements.filter(function (announcement: Announcement) {
            return announcement.AnnouncementType == type;
        });
    }

    closeClick() {
        if (!this.v10) {
            if (this.siteDailyAnnouncement.length > 0 && this.announcements.length == 0) {
                this.dialogRef.close();
            }
            else {
                this.announcements = [];
                if (this.siteDailyAnnouncement.length == 0) {
                    this.dialogRef.close();
                }
            }
        }
        else {
            this.dialogRef.close();
        }
    }

    moreClick(announcement: CardAnnouncement) {
        this.dialog.open(CardAnnouncementModalComponent, {
            data: announcement,
            disableClose: true,
            autoFocus: false,
            minWidth: '500px',
            maxWidth: '700px',
            maxHeight: '400px',
            minHeight: '300px'
        });
    }

    allAnnouncementsClick() {
        this.dialogRef.close();
        this.router.navigateByUrl('/student360/announcements');
    }
}
